export default {
  en: {
    labels: {
      no_matching_options: 'Sorry, no matching options.',
      loading: 'Loading',
      change_logo: 'Change Your Logo',
      upload_logo: 'Upload you Logo (at least 512x512)',
      password: 'Password',
      confirm_password: 'Confirm Password',
      forgot_password: 'Forgot password',
      back: 'Back',
      send: 'Send',
      login: 'Login',
      signup: 'Signup',
      go_to_app: 'Get App',
      change_role: 'Change',
      num_sales: 'N° Sales',
      gross_sales: 'Gross Sales',
      tot_donations: 'Tot Donations',
      num_donations: 'Donations',
      num_donors: 'Donors',
      referred_merchants: 'Referred Merchants',
      num_issues: 'N° Issues',
      sales: 'Sales',
      cancel: 'Cancel',
      ok: 'Ok',
      edit: 'Modifica',
      help: 'Help',
      topic: 'Topic',
      subject: 'Subject',
      message: 'Message',
      payments: 'Payments',
      refresh: 'Refresh',
      profile: 'Profile',
      payment_method: 'Payment Method',
      update: 'Update',
      save: 'Save',
      choose_img: 'Choose an Image',
      cover_img: 'Cover Image',
      change_cover_img: 'Change your cover image',
      upload_cover_img: 'Upload your cover image (min size 1080x1080)',
      go: 'Go',
      remove_option: 'Remove option',
      search_option: 'Search option',
      clear_selection: 'Clear selection',
      select_topic: 'Select a Topic',
      donations: 'Donations',
      affiliate: 'E-commerce',
      pos: 'In store',
      description: 'Description',
      subscribe: 'Subscribe',
      category: 'Category',
      followers: 'Followers',
      raised: 'Raised',
      support: 'Support',
      already_supported: 'Already Supported',
      qr_code: 'Your no-profit QrCode'
    },
    errors: {
      something_wrong: 'Something went wrong',
      address_required: 'A valid address is mandatory'
    },
    messages: {
      profile_updated: 'Profile updated!',
      pwd_renewed: 'Password Renewed',
      mail_sent: 'Mail sent!',
      payment_method_updated: 'Payment method updated!',
      payment_method_need_update: 'You need to update your payment method',
      payment_method_complete_form: 'You need to fill the form',
      help_request_sent: 'Assistance request sent, we will contact you as soon as possible',
      payment_not_available: 'Payment Method not Available'
    },
    sidebar_nav: {
      merchant_profile: 'Store profile',
      npo_profile: 'No-profit profile',
      npos: 'No-profits',
      ref_merchants: 'Referred Merchants',
      dashboard: 'Dashboard',
      help: 'Help',
      payments: 'Payments',
      donations: 'Donations',
      fees: 'Fees',
      pos_devices: 'Pos Devices',
      causes: 'Causes',
      logout: 'Logout'
    },
    datatables: {
      search: 'Search records',
      actions: 'Actions',
      order: 'Order',
      id_transaction: 'ID Tr.',
      status: 'Status',
      date: 'Date',
      release_date: 'Release date',
      amount: 'Amount',
      donation: 'Donation',
      type_transaction: 'Tr. Type',
      first: 'First',
      previous: 'Previous',
      next: 'Next',
      last: 'Last',
      date_placeholder: 'dd/mm/yyyy',
      all: 'All',
      paid: 'Paid',
      period: 'Period',
      waiting_payment: 'Waiting Payment',
      active: 'Attivi',
      inactive: 'Non Attivi',
      type_account: 'Account Type',
      credit_card: 'Credit Card',
      npo: 'No-profit',
      no_results: 'No Results',
      payment: 'Payment',
      refund: 'Refund',
      auth: 'Auth',
      id_terminal: 'Terminal ID',
      model: 'Model',
      serial_num: 'Serial N°',
      merchant: 'Merchant',
      donation_user: 'User Donation',
      donation_merchant: 'Merchant Donation',
      method: 'Channel',
      month: 'Month',
      year: 'Year',
      payments_num: 'N° Payments',
      payments_avg: 'Avg Donation',
      number_sepa_card: 'Account / Credit Card Number',
      payment_method: 'Payment Method'
    },
    payments: {
      payment: 'Payment',
      refund: 'Refund',
      auth: 'Auth',
      id_transaction: 'Transaction ID',
      id: 'ID',
      order: 'Order',
      date: 'Date',
      id_terminal: 'Terminal ID',
      amount: 'Amount',
      status: 'Payment Status',
      status_ok: 'Payment Succeded',
      status_not_ok: 'Unsuccesful Payment',
      operations: 'Operations',
      donapp: 'Donapp',
      donation: 'Donation',
      amount_donation: 'Amount',
      percentage: 'Percentage',
      donation_npo_merchant: 'To your No-profit',
      npo: 'No-profit'
    },
    donations: {
      donations: 'Donations',
      payments: 'Payments',
      id_donation: 'Donation ID',
      date: 'Date',
      period: 'Period',
      paid: 'Payment Status',
      paid_ok: 'Paid',
      paid_not_ok: 'Not Paid',
      paid_waiting: 'Waiting Confirmation',
      processed: 'Sent to Non-profit',
      processed_ok: 'Sent',
      processed_not_ok: 'Not sent yet',
      amount: 'Amount',
      amount_avg: 'Average Amount',
      payments_num: 'N° Payments',
      number_sepa_card: 'Account / Credit Card Number'
    },
    profile: {
      change_profile_photo: 'Change Profile Photo',
      status: 'Status',
      account_type: 'Account Type',
      company_profile: 'Company Profile',
      description: 'Description',
      category: 'Category',
      company_info: 'Company Information',
      ref_npo: 'Ref No-profit',
      company_name: 'Company Name',
      company_email: 'Company Email',
      tel: 'Telephone',
      vat: 'VAT',
      location: 'Address',
      donation_set_preferred_payment_method: 'Use as default',
      donation_payment_method_info: 'Here you can set, check and update the settings to pay your donations',
      donation_payment_method: 'Payment method:',
      donation_sepa_debit: 'SEPA Direct Debit',
      donation_credit_card: 'Donations Credit Card',
      sepa: 'SEPA Direct Debit',
      creditCard: 'Credit Card',
      name: 'Name',
      iban: 'Iban',
      npo_email: 'Organization email',
      npo_profile: 'Organization Profile',
      contact_info: 'Contact Information',
      website: 'Website',
      first_name: 'First Name',
      last_name: 'Last Name',
      ref_code: 'Referral Code',
      save: 'Save'
    },
    iban: {
      holder: 'Bank Account Holder',
      number: 'IBAN',
      email: 'Email'
    },
    credit_card: {
      holder: 'Card Holder',
      number: 'Card Number',
      brand: 'Brand',
      expire: 'Exp',
      cvc: 'CVC'
    },
    roles: {
      merchant: 'Store',
      npo: 'No-profit',
      user: 'User'
    },
    merchant_categories: {
      'restaurant-bar': 'Bar o Ristorante',
      grocery: 'Alimentari',
      'beauty-wellness': 'Bellezza e Benessere',
      sport: 'Articoli Sportivi',
      clothing: 'Abbigliamento e Accessori',
      furniture: 'Arredamento e oggetti per la casa',
      other: 'Altro'
    },
    npo_affiliate: {
      program: 'Affiliation Program',
      title: 'Refer a shop and collect 50% of every donation*!',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      duration: '*Affiliate programs last 1 year and can be renewed by the store'
    },
    charts: {
      no_data: 'No data to display',
      today: 'TODAY',
      num_sales: {
        title: 'Sales'
      },
      gross_sales: {
        title: 'Gross Sales'
      },
      num_donations: {
        title: 'Donations'
      },
      gross_donations: {
        title: 'Donated'
      },
      scanned: {
        title: 'QrCodes scanned Vs QrCodes not scanned',
        scanned: 'Scanned',
        not_scanned: 'Not Scanned'
      },
      returning: {
        title: 'Returning Customers',
        returning: 'Returning',
        onetime: 'Onetime',
        unknown: 'Unknown'
      },
      channels_donations: {
        title: 'Donation Channels',
        e_commerce: 'E-commerce',
        in_stores: 'In store'
      },
      merchants_vs_users_num: {
        title: 'Donations Referred Merchants Vs Donors',
        merchants: 'Merchants',
        donors: 'Donors'
      },
      merchants_vs_users_amount: {
        title: 'Donated Referred Merchants Vs Donors',
        merchants: 'Merchants',
        donors: 'Donors'
      },
      referred_merchants_types: {
        title: 'Referred Merchants Type',
        returning: 'Abituali',
        onetime: 'Occasionali',
        unknown: 'Sconosciuti'
      },
      price_range: {
        title: 'Price Range'
      }
    },
    date_picker: {
      short_days: {
        mon: 'M',
        tue: 'Tu',
        wed: 'W',
        thu: 'Th',
        fri: 'F',
        sat: 'Sa',
        sun: 'Su'
      },
      days: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      },
      months: {
        jan: 'January',
        feb: 'February',
        mar: 'March',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'August',
        sep: 'September',
        oct: 'October',
        nov: 'November',
        dec: 'December'
      }
    }
  },
  it: {
    labels: {
      no_matching_options: 'Nessuna opzione trovata',
      loading: 'Loading',
      change_logo: 'Cambia il tuo Logo',
      upload_logo: 'Carica il tuo Logo (minimo 512x512)',
      forgot_password: 'Password dimenticata?',
      password: 'Password',
      confirm_password: 'Conferma la password',
      back: 'Indietro',
      send: 'Invia',
      login: 'Entra',
      signup: 'Registrati',
      go_to_app: 'App',
      change_role: 'Entra',
      num_sales: 'N° Vendite',
      gross_sales: 'Incasso',
      tot_donations: 'Donato',
      num_donations: 'Donazioni',
      num_donors: 'Donatori',
      referred_merchants: 'Negozi affiliati',
      num_issues: 'N° Problemi',
      sales: 'Vendite',
      cancel: 'Annulla',
      ok: 'Ok',
      edit: 'Modifica',
      help: 'Assistenza',
      topic: 'Argomento',
      subject: 'Oggetto',
      message: 'Messaggio',
      payments: 'Vendite',
      refresh: 'Aggiorna',
      profile: 'Profilo',
      payment_method: 'Metodo di Pagamento',
      update: 'Aggiorna',
      save: 'Salva',
      choose_img: "Carica un'immagine",
      cover_img: 'Immagine di Copertina',
      change_cover_img: 'Imposta Immagine di Copertina',
      upload_cover_img: "Carica l'immagine di copertina (almeno 1080x1080)",
      go: 'Vai',
      remove_option: 'Rimuovi scelta',
      search_option: 'Cerca opzione',
      clear_selection: 'Rimuovi selezionato',
      select_topic: 'Scegli un argomento',
      donations: 'Donazioni',
      description: 'Descrizione',
      subscribe: 'Sottoscrivi',
      category: 'Categoria',
      followers: 'Followers',
      raised: 'Totale Raccolto',
      support: 'Supporta',
      already_supported: 'Già supportata',
      qr_code: 'Il QrCode della tua non profit'
    },
    errors: {
      something_wrong: 'Qualcosa è andato storto',
      address_required: 'Il campo Indirizzo deve essere valido'
    },
    messages: {
      profile_updated: 'Profilo aggiornato!',
      pwd_renewed: 'Password modificata!',
      mail_sent: 'Email inviata!',
      payment_method_updated: 'Metodo di pagamento aggiornato!',
      payment_method_need_update: "E' necessario aggiornare il proprio metodo di pagamento",
      payment_method_complete_form: 'Completa il modulo',
      help_request_sent: 'Richiesta inviata, ti contatteremo al più presto',
      payment_not_available: 'Metodo di pagamento non disponibile'
    },
    sidebar_nav: {
      merchant_profile: 'Profilo Negozio',
      npo_profile: 'Profilo Non profit',
      npos: 'Non profit',
      ref_merchants: 'Negozi Affiliati',
      dashboard: 'Dashboard',
      help: 'Assistenza',
      payments: 'Vendite',
      donations: 'Donazioni',
      fees: 'Commissioni',
      pos_devices: 'Dispositivi POS',
      causes: 'Cause',
      logout: 'Esci'
    },
    datatables: {
      search: 'Filtra risultati',
      actions: 'Azioni',
      order: 'Ordine',
      id_transaction: 'ID Tr.',
      status: 'Stato',
      date: 'Data',
      release_date: 'Data rilascio',
      amount: 'Importo',
      donation: 'Donato',
      type_transaction: 'Tipo Tr.',
      first: 'Prima',
      previous: 'Precedente',
      next: 'Prossima',
      last: 'Ultima',
      date_placeholder: 'gg/mm/aaaa',
      all: 'Tutti',
      paid: 'Pagato',
      period: 'Periodo',
      waiting_payment: 'Non pagato',
      active: 'Attivi',
      inactive: 'Non Attivi',
      type_account: 'Tipo Account',
      credit_card: 'Carta di Credito',
      npo: 'Non profit',
      no_results: 'Nessun risultato',
      payment: 'Pagamento',
      refund: 'Storno',
      auth: 'Autorizzativo',
      id_terminal: 'ID Terminale',
      model: 'Modello',
      serial_num: 'N° Seriale',
      merchant: 'Negozio',
      donation_user: 'Donazione Utente',
      donation_merchant: 'Donazione Negozio',
      method: 'Canale',
      affiliate: 'E-commerce',
      pos: 'In negozio',
      month: 'Mese',
      year: 'Anno',
      payments_num: 'N° Acquisti',
      payments_avg: 'Media Donazione',
      number_sepa_card: 'Numero Conto / Carta di Credito',
      payment_method: 'Metodo di Pagamento'
    },
    payments: {
      payment: 'Pagamento',
      refund: 'Storno',
      auth: 'Autorizzativo',
      id_transaction: 'ID Transazione',
      id: 'ID',
      order: 'Ordine',
      date: 'Data',
      id_terminal: 'ID Terminale',
      amount: 'Importo',
      status: 'Esito',
      status_ok: 'Pagamento riuscito',
      status_not_ok: 'Pagamento non riuscito',
      operations: 'Operazioni',
      donapp: 'Donapp',
      donation: 'Donazione',
      amount_donation: 'Importo',
      percentage: 'Percentuale',
      donation_npo_merchant: 'Alla tua Non profit',
      npo: 'Non profit'
    },
    donations: {
      donations: 'Donazioni',
      payments: 'Pagamenti',
      id_donation: 'ID Donazione',
      date: 'Data',
      period: 'Periodo',
      paid: 'Stato Pagamento',
      paid_ok: 'Pagato',
      paid_not_ok: 'Non pagato',
      paid_waiting: 'Attesa Conferma',
      processed: 'Invio alle Non-profit',
      processed_ok: 'Inviate',
      processed_not_ok: 'Ancora non inviate',
      amount: 'Donazione',
      amount_avg: 'Donazione media',
      payments_num: 'N° Acquisti',
      number_sepa_card: 'Numero Conto / Carta di Credito'
    },
    profile: {
      change_profile_photo: 'Cambia immagine profilo',
      status: 'Stato',
      account_type: 'Tipo Account',
      company_profile: 'Profilo Azienda',
      description: 'Descrizione',
      category: 'Categoria',
      company_info: 'Informazioni Azienda',
      ref_npo: 'Ref ONP',
      company_name: 'Nome Azienda',
      company_email: 'Email Azienda',
      tel: 'Telefono',
      vat: 'Partita IVA',
      location: 'Indirizzo',
      donation_set_preferred_payment_method: 'Usa come predefinito',
      donation_payment_method_info: 'Qui puoi impostare, controllare e modificare le impostazioni necessarie a pagare le donazioni',
      donation_payment_method: 'Metodo di Pagamento:',
      donation_sepa_debit: 'Addebito SEPA',
      donation_credit_card: 'Carta di Credito',
      sepa: 'Addebito SEPA',
      creditCard: 'Carta di Credito',
      name: 'Nome',
      iban: 'Iban',
      npo_email: 'Email Organizzazione',
      npo_profile: 'Profilo Organizzazione',
      contact_info: 'Informazioni di contatto',
      website: 'Sito Web',
      first_name: 'Nome',
      last_name: 'Cognome',
      ref_code: 'Codice Affiliati',
      save: 'Salva'
    },
    iban: {
      holder: 'Intestatario Conto',
      number: 'IBAN',
      email: 'Email comunicazioni'
    },
    credit_card: {
      holder: 'Intestatario Carta',
      number: 'Numero',
      brand: 'Brand',
      expire: 'Scadenza',
      cvc: 'CVC'
    },
    roles: {
      merchant: 'Negozio',
      npo: 'Non profit',
      user: 'Utente'
    },
    merchant_categories: {
      'restaurant-bar': 'Bar o Ristorante',
      grocery: 'Alimentari',
      'beauty-wellness': 'Bellezza e Benessere',
      sport: 'Articoli Sportivi',
      clothing: 'Abbigliamento e Accessori',
      furniture: 'Arredamento e oggetti per la casa',
      jewellery: 'Gioielleria',
      other: 'Altro'
    },
    npo_affiliate: {
      program: 'Programma di affiliazione',
      title: 'Diventa la organizzazione preferita dagli esercenti e assicurati il 50% delle loro donazioni*!',
      description:
        'Donapp prevede che la destinazione del 50% della donazione effettuata a seguito degli acquisti degli utenti/clienti Donapp è stabilita dal titolare dell’attività commerciale lasciando ai suoi clienti la scelta dell’organizzazione a cui destinare il restante 50%.\n\nPer garantirsi una fonte automatica, sicura, continuativa e costante di risorse nel tempo è quindi molto importante diventare la organizzazione scelta e sostenuta dagli esercizi commerciali.\n\nVi suggeriamo quindi di contattare gli esercizi commerciali che potete raggiungere attraverso la vostra rete di conoscenze e/o i vostri donatori che hanno anche una attività commerciale, per portarli nella rete Donapp se già non ne fanno parte, e chiedere loro di diventare la "loro" organizzazione.\n\nCoinvolgi subito i negozi che conosci!',
      duration: "*l'affiliazione dura 1 anno e può essere rinnovata"
    },
    charts: {
      no_data: 'Nessun dato da visualizzare',
      today: 'OGGI',
      num_sales: {
        title: 'Vendite'
      },
      gross_sales: {
        title: 'Incassi'
      },
      num_donations: {
        title: 'Donazioni'
      },
      gross_donations: {
        title: 'Donato'
      },
      scanned: {
        title: 'QrCode scansionati Vs QrCodes non scansionati',
        scanned: 'Scansionati',
        not_scanned: 'Non Scansionati'
      },
      returning: {
        title: 'Clienti abituali',
        returning: 'Abituali',
        onetime: 'Occasionali',
        unknown: 'Sconosciuti'
      },
      channels_donations: {
        title: 'Canali di donazione',
        e_commerce: 'E-commerce',
        in_stores: 'In negozio'
      },
      merchants_vs_users_num: {
        title: 'Donazioni Negozi Vs Utenti',
        merchants: 'Negozi',
        donors: 'Donatori'
      },
      merchants_vs_users_amount: {
        title: 'Donato Negozi Vs Utenti',
        merchants: 'Negozi',
        donors: 'Donatori'
      },
      referred_merchants_types: {
        title: 'Tipi negozi affiliati',
        returning: 'Abituali',
        onetime: 'Occasionali',
        unknown: 'Sconosciuti'
      },
      price_range: {
        title: 'Spesa media'
      }
    },
    date_picker: {
      short_days: {
        mon: 'L',
        tue: 'Ma',
        wed: 'Me',
        thu: 'G',
        fri: 'V',
        sat: 'S',
        sun: 'D'
      },
      days: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Gio',
        fri: 'Ven',
        sat: 'Sab',
        sun: 'Dom'
      },
      months: {
        jan: 'Gennaio',
        feb: 'Febbraio',
        mar: 'Marzo',
        apr: 'Aprile',
        may: 'Maggio',
        jun: 'Giugno',
        jul: 'Luglio',
        aug: 'Agosto',
        sep: 'Settembre',
        oct: 'Ottobre',
        nov: 'Novembre',
        dec: 'Dicembre'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/localization/index.js